import { render, staticRenderFns } from "./ItemsList.vue?vue&type=template&id=4f01f1cb&scoped=true"
import script from "./ItemsList.vue?vue&type=script&lang=js"
export * from "./ItemsList.vue?vue&type=script&lang=js"
import style0 from "./ItemsList.vue?vue&type=style&index=0&id=4f01f1cb&prod&lang=scss&scoped=true"
import style1 from "./ItemsList.vue?vue&type=style&index=1&id=4f01f1cb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f01f1cb",
  null
  
)

export default component.exports